<template>
<div>
  <v-row class="pa-5" justify=center>
      <span class="title-cgu">
      {{headerTitle}}
      </span>
  </v-row>
  <v-row class="pt-5" justify=center>
      <span class="subtitle-cgu">
      {{headerSubTitle}}
      </span>
  </v-row>
  </div>
</template>

<script lang='ts'>
import { Component, Vue } from 'vue-property-decorator';
@Component({})
export default class CGUBody extends Vue {
  get headerTitle(): string {
    return this.$t('cgu.title').toString();
  }
  get headerSubTitle(): string {
    return this.$t('cgu.subtitle').toString();
  }
}
</script>

<style lang='stylus'>
@import '../../stylus/main';
.cgu-title-parent {
}
.title-cgu {
  position absolute
  left: 50%;
  transform translateX(-50%);
  font-size 18px;
  font-weight bold;
  color: $deep-blue
}
.cgu-subtitle-parent {
  // position flex;
  // justify-content center
}
.subtitle-cgu {
  // flex 1;
  // align-content center;
  // left: 50%;
  // transform translateX(-50%);
  color $deep-blue
}
</style>
